import SvgIcon from '@mui/material/SvgIcon';

const ShoppingCartIcon = props => (
  <SvgIcon {...props} viewBox='0 0 35 36'>
    <path
      d='M26.0884 21.6031H13.0112L8.89358 9.25011H6.17645C5.89233 9.25011 5.66174 9.01953 5.66174 8.73541C5.66174 8.45129 5.89233 8.2207 6.17645 8.2207H9.63579L13.7534 20.5736H25.3472L28.1081 12.3384H12.3529C12.0688 12.3384 11.8382 12.1078 11.8382 11.8236C11.8382 11.5395 12.0688 11.3089 12.3529 11.3089H29.5389L26.0884 21.6031Z'
      fill='black'
      fillOpacity='0.56'
    />
    <path
      d='M15.4757 27.7795C14.0757 27.7795 12.9366 26.6405 12.9366 25.2405C12.9366 23.8405 14.0757 22.7014 15.4757 22.7014C16.8757 22.7014 18.0147 23.8405 18.0147 25.2405C18.0147 26.6405 16.8757 27.7795 15.4757 27.7795ZM15.4757 23.7313C14.6434 23.7313 13.9661 24.4082 13.9661 25.241C13.9661 26.0738 14.6434 26.7501 15.4757 26.7501C16.308 26.7501 16.9853 26.0733 16.9853 25.2405C16.9853 24.4077 16.3085 23.7313 15.4757 23.7313Z'
      fill='#414042'
    />
    <path
      d='M23.6765 27.7451C22.2765 27.7451 21.1375 26.606 21.1375 25.206C21.1375 23.806 22.2765 22.667 23.6765 22.667C25.0765 22.667 26.2155 23.806 26.2155 25.206C26.2155 26.606 25.0765 27.7451 23.6765 27.7451ZM23.6765 23.6964C22.8442 23.6964 22.1669 24.3732 22.1669 25.206C22.1669 26.0388 22.8437 26.7157 23.6765 26.7157C24.5093 26.7157 25.1861 26.0388 25.1861 25.206C25.1861 24.3732 24.5088 23.6964 23.6765 23.6964Z'
      fill='#414042'
    />
    <path
      d='M16.4701 19.5765C16.2292 19.5765 16.014 19.4066 15.9657 19.1611L14.9363 13.9497C14.8812 13.6708 15.0624 13.4 15.3413 13.3449C15.6203 13.2894 15.8905 13.4716 15.9461 13.75L16.9755 18.9614C17.0306 19.2399 16.8494 19.5106 16.5704 19.5662C16.5365 19.5734 16.503 19.5765 16.4701 19.5765Z'
      fill='#DC0032'
    />
    <path
      d='M22.6476 19.5766C22.6147 19.5766 22.5812 19.5735 22.5478 19.5668C22.2688 19.5118 22.0871 19.2405 22.1422 18.9621L23.1716 13.7507C23.2266 13.4717 23.4979 13.2895 23.7764 13.3456C24.0553 13.4007 24.237 13.6714 24.1819 13.9504L23.1525 19.1618C23.1036 19.4063 22.8885 19.5766 22.6476 19.5766Z'
      fill='#DC0032'
    />
    <path
      d='M19.5588 19.5765C19.2741 19.5765 19.0441 19.3464 19.0441 19.0618V13.8504C19.0441 13.5663 19.2741 13.3357 19.5588 13.3357C19.8434 13.3357 20.0735 13.5663 20.0735 13.8504V19.0618C20.0735 19.3459 19.8434 19.5765 19.5588 19.5765Z'
      fill='#DC0032'
    />
  </SvgIcon>
);

export default ShoppingCartIcon;
